import { transport } from 'config/transport';

export function callApiCreateKhanDong(congDoanId, nunId, body) {
    return transport.post(`/congdoan/${congDoanId}/khandong/${nunId}`, body);
}
